<template>
  <div v-if="!newRefresh">
    <date-picker
      :value="value ? calcValue(value) : null"
      :mode="mode"
      :type="type"
      :column="column"
      :locale="locale"
      :shortcut="isShortcut"
      :initial-value="initialVal"
      :autoSubmit="autoSubmit"
      :data-key="keyToUpdate"
      :locale-config="
        type === 'datetime'
          ? {
              fa: {
                inputFormat: 'jYYYY/jMM/jDD HH:mm',
              },
              en: {
                format: 'YYYY-MM-DD HH:mm',
              },
            }
          : type === 'time'
          ? {
              fa: {
                inputFormat: 'HH:mm:ss',
              },
              en: {
                format: 'HH:mm:ss',
              },
            }
          : {
              fa: {
                inputFormat: 'jYYYY/jMM/jDD',
              },
              en: {
                format: 'YYYY-MM-DD',
              },
            }
      "
      click-on="all"
      format="YYYY-MM-DD HH:mm"
      :to="to"
      :from="from"
      :clearable="clearbleStatus"
      :disabled="disabled"
      :show="false"
      :auto-submit="false"
      :id="`date-picker-${Array.isArray(value) ? value : value}`"
      :ref="`date-picker-${Array.isArray(value) ? value : value}`"
      class="form-control p-0"
      style="height: 38px"
      @select="selected"
      @submit="dateSubmitted"
    >
      <!-- v-model="dateOfBirth" -->
      <template v-if="value" #clear>
        <b-icon
          @click="$emit('input', null)"
          scale="2"
          aria-hidden="true"
          icon="x"
        ></b-icon>
      </template>
    </date-picker>
  </div>
</template>

<script>
import datePicker from "@alireza-ab/vue-persian-datepicker";
import moment from "jalali-moment";
import dateFormat from "@/mixins/dateFormat";

export default {
  name: "MyAbDatePicker",
  data() {
    return {
      dateInfo: [],
      keyToUpdate: 0,
      newRefresh: false
    };
  },
  components: { datePicker },
  methods: {
    calcValue(value) {
      if (Array.isArray(value)) {
        if (this.type === "datetime") {
          return this.arrayToUTC(value, true);
        } else if (this.type === "time") {
          return value;
        } else {
          return this.arrayToUTC(value, false);
        }
      } else {
        return this.toUTC(value);
      }
    },
    selected(value) {
      let dateInfo;
      if (this.mode === "single") {
        dateInfo =
          value.d.year +
          "/" +
          value.d.month +
          "/" +
          value.d.date +
          " " +
          value.d.hour +
          ":" +
          value.d.minute +
          ":" +
          value.d.second;
        if (value.c === "jalali") {
          dateInfo = this.toUTC(this.toGreg(dateInfo));
        }
        this.$emit("select", this.toIso ? this.toIsoDate(dateInfo) : dateInfo);
        this.$emit("input", this.toIso ? this.toIsoDate(dateInfo) : dateInfo);
      } else {
        // if (this.dateInfo.length === 2) {
        //   this.dateInfo = []
        //
        // }
        // this.dateInfo.push(value)
        //
        // if (this.dateInfo.length <= 1) {
        //   // this.dateInfo = []
        //   // this.dateInfo.forEach((v, index) => {
        //   //   dateInfo[index] = v.d.year + "/" + v.d.month + "/" + v.d.date + ' ' + v.d.hour + ':' + v.d.minute + ':' + v.d.second;
        //   //   if (v.c === "jalali") {
        //   //     dateInfo[index] = this.toUTC(this.toGreg(dateInfo[index]));
        //   //   }
        //   // });
        // }
        // if(this.toIso){
        //   dateInfo = this.dateInfo.map(d => {
        //     return this.toIsoDate(d)
        //   })
        // }
        // // if (this.dateInfo.length === 2){
        // //
        //   this.$emit("select", dateInfo);
        //   this.$emit("input", dateInfo);
        // // }
      }
    },
    dateSubmitted(value) {
      const parent = this;
      if (value.length === 2) {
        let dateInfo;
        if (this.toIso) {
          dateInfo = value.map((d) => {
            if (parent.customHour) d.d.hour = parent.customHour;
            return this.toIsoDateTime(d);
          });
        } else {
          dateInfo = value;
        }
        this.$emit("select", dateInfo);
        this.$emit("input", dateInfo);
      }
    },
    dateInput(value) {
      let dateInfo;
      // if (value){
      if (this.mode === "single") {
        dateInfo =
          value.d.year +
          "/" +
          value.d.month +
          "/" +
          value.d.date +
          " " +
          value.d.hour +
          ":" +
          value.d.minute +
          ":" +
          value.d.second;
        if (value.c === "jalali") {
          dateInfo = this.toUTC(this.toGreg(dateInfo));
        }
      } else {
        dateInfo = [];
        value.forEach((v, index) => {
          dateInfo[index] =
            v.d.year +
            "/" +
            v.d.month +
            "/" +
            v.d.date +
            " " +
            v.d.hour +
            ":" +
            v.d.minute +
            ":" +
            v.d.second;
          if (v.c === "jalali") {
            dateInfo[index] = this.toUTC(this.toGreg(dateInfo[index]));
          }
        });
      }
      // this.$emit("input", this.toIso ? this.toIsoDate(dateInfo) : dateInfo);
    },
  },
  mixins: [dateFormat],
  created(){
    if(this.newRefresh == true){
      setTimeout(() => {
          this.newRefresh = false
      },5)
    }
  },
  props: {
    to: {
      // default: moment.from(new Date()).locale("fa").format("YYYY/MM/DD"),
      // default: moment.from(new Date()).locale("en").format("YYYY MM  DD, hh:mm:ss")
    },
    isShortcut: {
      default: false,
      type: Boolean,
    },
    from: {
      default: "1300",
      // default: moment.from(new Date()).locale("en").format("YYYY MM  DD, hh:mm:ss")
    },
    locale: {
      default: "fa,en",
    },
    column: {
      default: 1,
    },
    mode: {
      default: "single",
    },
    type: {
      default: "date",
    },
    toIso: {
      default: true,
      type: Boolean,
    },
    value: {
      //  default: moment.from(new Date()).locale("en").format("YYYY MM  DD, hh:mm:ss")
      default: null,
    },
    autoSubmit: {
      default: false,
    },
    timezone: {
      default: false,
    },
    customHour: {
      default: false,
    },
    disabled: {
      default: false,
    },
    clearbleStatus: {
      defualt: true
    },
    initialVal:{
      default: null
    },
  },
  watch: {
    value(newVal,oldVal){
      if (newVal != oldVal){
        this.newRefresh = true
        this.keyToUpdate++;
        setTimeout(() => {
          this.newRefresh = false
        },5)
       
      }
    }
  },
};
</script>
<style>
.pdp .pdp-picker .pdp-shortcut li {
    width: max-content;
}
</style>
